"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const MiniProviderCard_styles_1 = require("./MiniProviderCard.styles");
const constants_1 = require("../common/util/constants");
const useProviderContent_1 = require("../common/util/useProviderContent");
/** Renders a button to view the profile of a provider.
/**
/** @param {ViewProfileButtonProps} props - The component props. */
/** @param {Provider} props.provider - The provider object. */
/** @param {Config} props.config - The configuration object. */
/** @param {Availability} props.availability - The availability object. */
/** @param {Function} props.onViewProvider - The callback function to handle the view provider action. */
/** @param {string} props.viewProviderUrl - The URL to view the provider profile. */
/** @param {string} props.viewProviderLinkTarget - The target attribute for the view provider link. */
/** @returns {ReactElement} The rendered ViewProfileButton component. */
const ViewProfileButton = ({ provider, config, availability, onViewProviderCTA, viewProviderUrl, viewProviderLinkTarget }) => {
    const { id } = (0, useProviderContent_1.useProviderContent)({
        provider,
        availability,
        config
    });
    return (react_1.default.createElement(MiniProviderCard_styles_1.AvailabilityButton, { "data-testid": `mini-provider-card-profile-button-${id}`, rel: "noopener noreferrer", target: viewProviderLinkTarget, href: viewProviderUrl, onClick: onViewProviderCTA, draggable: false, "aria-hidden": true },
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, constants_1.messages.viewProfile))));
};
exports.default = (0, intl_1.injectIntl)(ViewProfileButton);
//# sourceMappingURL=ViewProfileButton.js.map